import React from 'react'
import Health from '../pages/images/health.jpg'
import Homehealth from '../pages/images/homehealth.jpg'
import Healthcheck from '../pages/images/checkup.jpg'
import Emergency from '../pages/images/emergency.jpg'

const Services = () => {
    return (
        <>

            <center><h1>Our Services</h1></center>


            <div className='services'>


                <div className='serveds2'>
                    <img src={Emergency} />
                    <h1>Emergency 24*7
                    </h1>
                    <p>In commerce and industry, 24/7 or 24-7 service (usually pronounced "twenty-four seven") is service that is available at any time and usually, every day. </p>

                </div>

                <div className='serveds2'>
                    <img src={Healthcheck} />
                    <h1>Health Check</h1>
                    <p>A health check, also known as a checkup, exam, or medical examination, is a thorough physical examination that assesses a person's overall health. </p>
                </div>


                <div className='serveds2'>
                    <img src={Health} />
                    <h1>Health care</h1>
                    <p>Health care, or healthcare, is the improvement of health via the prevention, diagnosis, treatment, amelioration or cure of disease, illness, injury, and other physical and mental impairments in people. </p>
                </div>

                <div className='serveds2'>
                    <img src={Homehealth} />
                    <h1>Home Health Service</h1>
                    <p>Home care is care that allows a person with special needs to stay in their home. It might be for people who are getting older (aging in place).</p>

                </div>





            </div>

        </>
    )
}

export default Services
